jQuery(document).ready(function() {

    //HOME
    jQuery('#avantagesCarousel').carousel({interval:false});

    jQuery(".nav-main").clone().prependTo("#off-canvas");
    jQuery(function () {
        jQuery(document).trigger("enhance");
    });

    jQuery('#off-canvas').offcanvas({});

});


// WEBPACK FOOTER //
// ./assets/js/theme.js